// extracted by mini-css-extract-plugin
export default {"container":"List_container__XoOoj","containerSmallNav":"List_containerSmallNav__T91XV"};